import { render, staticRenderFns } from "./DashboardYoutube.vue?vue&type=template&id=e35002fa&scoped=true&"
import script from "./DashboardYoutube.vue?vue&type=script&lang=js&"
export * from "./DashboardYoutube.vue?vue&type=script&lang=js&"
import style0 from "./DashboardYoutube.vue?vue&type=style&index=0&id=e35002fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e35002fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VTabItem,VTabsItems})
